"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var comboEditor_1 = require("./cellProvider/comboEditor");
var numberEditorConverter_1 = require("./cellProvider/numberEditorConverter");
var posterComboEditor_1 = require("./cellProvider/posterComboEditor");
var urlHelper_1 = require("./cellProvider/urlHelper");
var configuration_1 = require("./configuration");
var treeManager_1 = require("./datalayer/treeManager");
var disabledEditorManager_1 = require("./disabledEditorManager");
var planeditor_1 = require("./planeditor");
var ExtDiv_1 = require("./popups/ExtDiv");
var gridTextField_1 = require("./uiElements/gridTextField");
var numeralTextRender_1 = require("./uiElements/numeralTextRender");
var CellEditorsProvider = (function (_super) {
    __extends(CellEditorsProvider, _super);
    function CellEditorsProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CellEditorsProvider.prototype.setColumnSet = function (columnSet) {
        throw new Error("not implemented");
    };
    CellEditorsProvider.prototype.setReadOnlyMask = function (isRowReadOnly) {
        throw new Error("not implemented");
    };
    CellEditorsProvider.prototype.setCheckboxEnabled = function (grid, row, path, state) {
        throw new Error("not implemented");
    };
    CellEditorsProvider.prototype.setPosterController = function (posterController) {
        throw new Error("not implemented");
    };
    CellEditorsProvider.prototype.stopEditingOnAllGrids = function () {
        throw new Error("not implemented");
    };
    return CellEditorsProvider;
}(zebra.ui.grid.DefEditors));
exports.CellEditorsProvider = CellEditorsProvider;
exports.cellEditorProviderClass = zebra.Class(zebra.ui.grid.DefEditors, [
    function (font, smallFont, options) {
        options = options || {};
        this.$super();
        this._font = font;
        this._smallFont = smallFont;
        this._editAdFormatOnline = options.editAdFormatOnline;
        this._editTargeting = options.editTargeting;
        this._editSpecialPrice = options.editSpecialPrice;
        this._editAdFormatCommon = options.editAdFormatCommon;
        this._editPeriod = options.editPeriod;
        this._isRowReadOnly = [];
        this.disabledEditorManager = new disabledEditorManager_1.DisabledEditorManager();
        this.type = options.type;
        if (this.isTopApi()) {
            this.treeManager = new treeManager_1.TreeManager();
        }
    },
    function isTopApi() {
        return this.type === "top";
    },
    function isStroerApi() {
        return this.type === "stroer";
    },
    function setPosterController(posterController) {
        this.posterController = posterController;
    },
    function setColumnSet(columnSet) {
        this.columns = columnSet.columns;
    },
    function setReadOnlyMask(isRowReadOnly) {
        this._isRowReadOnly = isRowReadOnly || [];
    },
    function isMediumTypeInColumnTypes(mediumType, columnTypes) {
        if (!columnTypes || !mediumType) {
            return true;
        }
        return columnTypes.indexOf(mediumType.toString().toLowerCase()) !== -1;
    },
    function handleLink(value) {
        if (urlHelper_1.UrlHelper.isEmailAdress(value)) {
            var emailWindow_1 = window.open("mailto:" + value, "Mailer");
            var delayTimeInMs = 10;
            setTimeout(function () {
                emailWindow_1.close();
            }, delayTimeInMs);
        }
        else if (urlHelper_1.UrlHelper.isUrl(value)) {
            window.open("http://" + value, "_blank");
        }
    },
    function handleAdformat(value, isPresetRow, mediumType) {
        value = _.assign(value, { isPresetRow: isPresetRow });
        return new ExtDiv_1.extDivClass(this._editAdFormatOnline, (function () {
            return new Promise(function (resolve, reject) {
                resolve(value);
            });
        }));
    },
    function handlePeriodPopup(value) {
        return new ExtDiv_1.extDivClass(this._editPeriod, (function () {
            return new Promise(function (resolve, reject) {
                resolve(value);
            });
        }));
    },
    function handleTargeting(value) {
        return new ExtDiv_1.extDivClass(this._editTargeting, treeManager_1.TreeManager.getTargetingTreeFactory(value.medium, value.adFormat, value.keys || [], value.mediumPrettyName, value.adFormatPrettyName, value.wastage, value.informationHandler, value.frequencyCapping, value.periodPrettyName, value.plan, value.ratecardHasTargeting, value.dates));
    },
    function handleSpecialPrice(value) {
        return new ExtDiv_1.extDivClass(this._editSpecialPrice, function () { return Promise.resolve({ value: value }); });
    },
    function getCheckboxPanel(column, grid, row, col, value) {
        var _this = this;
        if (!this.disabledEditorManager.isEnabled(column, row)) {
            return undefined;
        }
        var theCheckBox = new zebra.ui.Checkbox();
        if (value !== configuration_1.PlanConfiguration.ERROR_STRING && value !== false) {
            theCheckBox.setValue(true);
        }
        theCheckBox.manager.bind(function (src, ui) {
            _this.setNewValueAccordingToGrid(grid, row, col, ui.getValue());
            if (_this._handler) {
                _this._handler();
            }
        });
        var centerPan = new zebra.ui.Panel(new zebra.layout.FlowLayout(zebra.layout.CENTER, zebra.layout.CENTER, zebra.layout.VERTICAL));
        centerPan.add(theCheckBox);
        return centerPan;
    },
    function setNewValueAccordingToGrid(grid, row, col, value) {
        grid.setEditedData(row, col, value);
        grid.stopEditing();
    },
    function getButton(column, row) {
        if (this.addRowHandler && _.get(column, "editor.handler")) {
            try {
                var theButton = new zebra.ui.Label("");
                theButton.mousePressed = (this[column.editor.handler]([row]));
                return undefined;
            }
            catch (error) {
                throw new Error("FATAL: handler " + column.editor.handler + "not found!");
            }
        }
        return undefined;
    },
    function handleEditor(grid, row, col, mediumType, value) {
        var _this = this;
        if (value === void 0) { value = configuration_1.PlanConfiguration.ERROR_STRING; }
        var theColumn = this.columns[col];
        var isPresetRow = grid["isPresetRow"] || false;
        switch (theColumn.editor.type) {
            case planeditor_1.COLUMN_EDITORS.AD_FORMAT:
                return this.handleAdformat(value, isPresetRow, mediumType);
            case planeditor_1.COLUMN_EDITORS.TARGETING:
                return this.handleTargeting(value);
            case planeditor_1.COLUMN_EDITORS.SPECIAL_PRICE:
                return this.handleSpecialPrice(value);
            case planeditor_1.COLUMN_EDITORS.PERIOD:
                return this.handlePeriodPopup(value);
            case planeditor_1.COLUMN_EDITORS.DROP_DOWN:
                var comboEditor = void 0;
                if (this.isStroerApi()) {
                    comboEditor = new posterComboEditor_1.PosterComboEditor();
                    comboEditor.setPosterAdditionalInformation(theColumn, this.rows, isPresetRow, row, this.posterController);
                }
                else {
                    comboEditor = new comboEditor_1.ComboEditor();
                }
                var newValueFunction = function (newValue) {
                    _this.setNewValueAccordingToGrid(grid, row, col, newValue);
                };
                comboEditor.generateCombo(theColumn, value, this._font, this._smallFont, grid.getColWidth(col), newValueFunction, this);
                return comboEditor.combo;
            case planeditor_1.COLUMN_EDITORS.CHECKBOX:
                return this.getCheckboxPanel(theColumn, grid, row, col, value);
            case planeditor_1.COLUMN_EDITORS.TEXT_FIELD:
                break;
            default:
                throw new Error("FATAL: Unexpected editor type encountered!");
        }
    },
    function getMediumType(row, theColumn) {
        var mediumType;
        if (this.rows) {
            var theRow = this.rows[row];
            var columnTypes = _.get(theColumn, "types");
            mediumType = _.get(theRow, "medium.tariffConditionId");
            if (!this.isMediumTypeInColumnTypes(mediumType, columnTypes)) {
                return undefined;
            }
        }
        if (!mediumType && this.isTopApi()) {
            mediumType = "OnlineMedium";
        }
        return mediumType;
    },
    function getEditor(grid, row, col, value) {
        if (value === void 0) { value = configuration_1.PlanConfiguration.ERROR_STRING; }
        this.stopEditingOnAllGrids();
        var theColumn = this.columns[col];
        var mediumType = this.getMediumType(row, theColumn);
        var editorIsReadOnly = _.get(theColumn, "settings.readonlyWhenUndefined") &&
            value === configuration_1.PlanConfiguration.ERROR_STRING &&
            !grid["isPresetRow"];
        if (editorIsReadOnly) {
            return undefined;
        }
        if (value === configuration_1.PlanConfiguration.ERROR_STRING) {
            var textOnEmpty = _.get(theColumn, "settings.textOnEmpty");
            value = textOnEmpty !== undefined ? textOnEmpty : configuration_1.PlanConfiguration.ERROR_STRING;
        }
        if (theColumn.dataType === planeditor_1.DATA_TYPES.LINK && value !== configuration_1.PlanConfiguration.ERROR_STRING) {
            this.handleLink(value);
        }
        if (theColumn.editor && !this._isRowReadOnly[row]) {
            if (grid.addSelectedRow) {
                grid.addSelectedRow(row);
            }
            if (theColumn.editor.type === planeditor_1.COLUMN_EDITORS.BUTTON) {
                return this.getButton(theColumn, row);
            }
            var editor = this.handleEditor(grid, row, col, mediumType, value);
            if (!this.disabledEditorManager.isEnabled(theColumn, row)) {
                return undefined;
            }
            if (editor) {
                return editor;
            }
        }
        else {
            return undefined;
        }
        var dataType = theColumn.dataType;
        var theTextRender;
        if (dataType === planeditor_1.DATA_TYPES.NUMBER || dataType === planeditor_1.DATA_TYPES.CURRENCY) {
            theTextRender = new numeralTextRender_1.numeralTextRender("");
            theTextRender.isInteger(theColumn.settings && theColumn.settings.numberFormat === configuration_1.PlanConfiguration.NUMBER_FORMAT_INTEGER);
        }
        else {
            theTextRender = new zebra.ui.TextRender("");
        }
        var textField = new gridTextField_1.gridTextField(grid, row, col, theTextRender);
        textField.setBorder("plain");
        textField.setFont(this._font);
        textField.setColor(configuration_1.PlanConfiguration.tableColor);
        textField.setPadding(1, textField.getLeft(), textField.getBottom(), textField.getRight());
        textField.setBackground(configuration_1.PlanConfiguration.textFieldBackground);
        switch (theColumn.dataType) {
            case planeditor_1.DATA_TYPES.NUMBER:
                textField.setValue(numberEditorConverter_1.NumberToEditorStringConverter.number2Editor(value, theColumn.settings));
                break;
            default:
                textField.setValue(value.toString());
        }
        textField.select(0, textField.getValue().length);
        textField.setSelectionColor(configuration_1.PlanConfiguration.textFieldSelectionColor);
        return textField;
    },
    function stopEditingOnAllGrids() {
        _.noop();
    },
    function fetchEditedValue(grid, row, col, data, editor) {
        var column = this.columns[col];
        if (column.editor) {
            switch (column.editor.type) {
                case planeditor_1.COLUMN_EDITORS.TARGETING:
                    var result = editor.getResult();
                    var targetingResult = _.assign({}, data, {
                        keys: result.keys, wastage: result.wastage, shortCaption: result.shortCaption
                    });
                    return targetingResult;
                case planeditor_1.COLUMN_EDITORS.AD_FORMAT:
                    var adformatResult = editor.getResult();
                    return adformatResult;
                case planeditor_1.COLUMN_EDITORS.SPECIAL_PRICE:
                    var theResultData = editor.getResult();
                    return theResultData;
                case planeditor_1.COLUMN_EDITORS.CHECKBOX:
                    return editor.kids[0].getValue();
                case planeditor_1.COLUMN_EDITORS.DROP_DOWN:
                    return data;
                case planeditor_1.COLUMN_EDITORS.TEXT_FIELD:
                    break;
                case planeditor_1.COLUMN_EDITORS.BUTTON:
                    return;
                case planeditor_1.COLUMN_EDITORS.PERIOD:
                    var periodResult = editor.getResult();
                    return periodResult;
                default:
                    break;
            }
        }
        switch (this.columns[col].dataType) {
            case planeditor_1.DATA_TYPES.NUMBER:
                return numberEditorConverter_1.NumberToEditorStringConverter.editor2Number(editor.getValue(), this.columns[col].settings);
            default:
                return this.$super.apply(this, arguments);
        }
    },
    function setCheckboxEnabled(grid, row, path, state) {
        this.disabledEditorManager.setEditorEnabled(grid, row, path, state);
    }
]);
//# sourceMappingURL=CellEditorProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/CellEditorProvider.js
// module id = 15
// module chunks = 0